class ListColumnManager extends Tango.Component {
    widgetDidMount() {
        draggableTable(this.root, () => {
            const root = document.getElementById(this.root);
            const rows = root.querySelectorAll('tr');
            const h = root.parentElement.querySelector("input[name='mngcol_order']");
            h.value = Array.from(rows).map(row => row.getAttribute('data-id')).join(',');
        });
	}
}

class StaticTreeDialog extends Tango.Component {
	widgetWillMount(shadowDoc) {
		const root = shadowDoc.getElementById(this.root);
		root.querySelectorAll('input[type=radio]').forEach(el => {
			el.addEventListener("change", e => {
				root.setAttribute('data-level', '2');
			});
		})
		root.querySelectorAll('.level-title').forEach(el => {
			el.addEventListener("click", e => {
				var l = parseInt(root.getAttribute('data-level'));
				l--;
				root.setAttribute('data-level', l);
				e.currentTarget.parentElement.previousSibling.checked = false;
			});
		})

		// Поиск по всему дереву: не рисуем второй, плоский список (он продублировал бы
		// id/name чекбоксов col_<id>), а показываем сразу все категории и прячем строки,
		// которые не подошли. Пустой запрос возвращает дерево на первый уровень.
		const search = root.querySelector('.treesearch');
		if (search) {
			search.addEventListener('input', () => {
				const q = search.value.trim().toLowerCase();

				if (!q) {
					root.setAttribute('data-level', '1');
					root.querySelectorAll('.level-2 tr').forEach(tr => tr.style.display = '');
					root.querySelectorAll('.level-2').forEach(d => d.style.display = '');
					return;
				}

				root.setAttribute('data-level', 'search');
				root.querySelectorAll('.level-2').forEach(d => {
					var found = 0;
					d.querySelectorAll('tr').forEach(tr => {
						const match = (tr.textContent || '').toLowerCase().indexOf(q) >= 0;
						tr.style.display = match ? '' : 'none';
						if (match) found++;
					});
					d.style.display = found ? '' : 'none';
				});
			});
		}
	}
}

Tango.registerComponent(ListColumnManager);
Tango.registerComponent(StaticTreeDialog);

function draggableTable(tableId, onDrop) {
    const table = document.getElementById(tableId);
    const tbody = table.querySelector('tbody');

    var currRow = null,
        dragElem = null,
        mouseDownX = 0,
        mouseDownY = 0,
        mouseX = 0,
        mouseY = 0,
        mouseDrag = false;

    function swapRow(row, index) {
        let currIndex = Array.from(tbody.children).indexOf(currRow),
            row1 = currIndex > index ? currRow : row,
            row2 = currIndex > index ? row : currRow;

        tbody.insertBefore(row1, row2);
    }

    function moveRow(x, y) {
        dragElem.style.transform = "translate3d(" + x + "px, " + y + "px, 0)";

        let dPos = dragElem.getBoundingClientRect(),
            currStartY = dPos.y, currEndY = currStartY + dPos.height,
            rows = getRows();

        for (var i = 0; i < rows.length; i++) {
            let rowElem = rows[i],
                rowSize = rowElem.getBoundingClientRect(),
                rowStartY = rowSize.y, rowEndY = rowStartY + rowSize.height;

            if (currRow !== rowElem && isIntersecting(currStartY, currEndY, rowStartY, rowEndY)) {
                if (Math.abs(currStartY - rowStartY) < rowSize.height / 2)
                    swapRow(rowElem, i);
            }
        }
    }

    function addDraggableRow(target) {
        dragElem = target.cloneNode(true);
        dragElem.classList.add('draggable-table__drag');
        dragElem.style.height = getStyle(target, 'height');
        dragElem.style.background = getStyle(target, 'backgroundColor');
        for (var i = 0; i < target.children.length; i++) {
            let oldTD = target.children[i],
                newTD = dragElem.children[i];
            newTD.style.width = getStyle(oldTD, 'width');
            newTD.style.height = getStyle(oldTD, 'height');
            newTD.style.padding = getStyle(oldTD, 'padding');
            newTD.style.margin = getStyle(oldTD, 'margin');
        }

        table.appendChild(dragElem);

        var parentOffset = commonUtils.getParentOffset(target);
        let tPos = target.getBoundingClientRect(),
            dPos = dragElem.getBoundingClientRect();
        dragElem.style.bottom = ((dPos.y - tPos.y) + parentOffset.top) + "px";
        dragElem.style.left = "-1px";

        document.dispatchEvent(new MouseEvent('mousemove',
            { view: window, cancelable: true, bubbles: true }
        ));
    }

    function getRows() {
        return table.querySelectorAll('tbody tr:not(.draggable-table__drag)');
    }

    function getTargetRow(target) {
        let elemName = target.tagName.toLowerCase();

        if (elemName == 'tr')
            return target;
        else
            return target.closest('tr');
    }

    function getMouseCoords(event) {
        return {
            x: event.clientX,
            y: event.clientY
        };
    }

    function getStyle(target, styleName) {
        let compStyle = getComputedStyle(target),
            style = compStyle[styleName];

        return style ? style : null;
    }

    function isIntersecting(min0, max0, min1, max1) {
        return Math.max(min0, max0) >= Math.min(min1, max1) &&
            Math.min(min0, max0) <= Math.max(min1, max1);
    }

    function mouseDownHandler(event) {
        if (event.button != 0) return true;

        let target = getTargetRow(event.target);
        if (target) {
            currRow = target;
            addDraggableRow(target);
            currRow.classList.add('is-dragging');

            let coords = getMouseCoords(event);
            mouseDownX = coords.x;
            mouseDownY = coords.y;

            mouseDrag = true;
        }
    }

    table.querySelectorAll('td.draggable').forEach(function (el, index) {
        el.addEventListener('mousedown', mouseDownHandler);
    });

    document.addEventListener('mousemove', (event) => {
        if (!mouseDrag) return;

        let coords = getMouseCoords(event);
        mouseX = coords.x - mouseDownX;
        mouseY = coords.y - mouseDownY;

        moveRow(mouseX, mouseY);
    });

    document.addEventListener('mouseup', (event) => {
        if (!mouseDrag) return;

        currRow.classList.remove('is-dragging');
        table.removeChild(dragElem);

        dragElem = null;
        mouseDrag = false;

        if (onDrop) onDrop();
    });
}